//pair each web page name (from the URL) with a banner image
var page_banners = { 
    "archives": 'https://cdn.shopify.com/s/files/1/1751/8229/files/Archives-banner.jpg?1143050079730948627', 
    "tribal-historic-preservation-office": 'https://cdn.shopify.com/s/files/1/1751/8229/files/THPO-banner.jpg?1143050079730948627', 
    "faqs": 'https://cdn.shopify.com/s/files/1/1751/8229/files/FAQs-banner-50H.jpg?10434571479115257604',
    "camp-kic-a-wah": 'https://cdn.shopify.com/s/files/1/1751/8229/files/Childrens-Services-banner_9ac430eb-1286-4ea0-853a-6148fd034016.jpg?1143050079730948627', 
    "programs": 'https://cdn.shopify.com/s/files/1/1751/8229/files/Programs-banner.jpg?1143050079730948627', 
    "catawba-cultural-center-classes-workshops": 'https://cdn.shopify.com/s/files/1/1751/8229/files/Classes-and-Workshops-banner.jpg?1143050079730948627',
    "about-us": 'https://cdn.shopify.com/s/files/1/1751/8229/files/About-Us-banner_0cb68064-7a6f-4c10-9179-da5bb673cb1b.jpg?1143050079730948627', 
    "team": 'https://cdn.shopify.com/s/files/1/1751/8229/files/The-Team-banner.jpg?1143050079730948627', 
    "meet-the-artists": 'https://cdn.shopify.com/s/files/1/1751/8229/files/Meet-The-Artists-2-banner.jpg?6809299148537589817', 
    "contact-us": 'https://cdn.shopify.com/s/files/1/1751/8229/files/Contact-Us-banner.jpg?1143050079730948627', 
    "news": 'https://cdn.shopify.com/s/files/1/1751/8229/files/News-banner.jpg?7985532085333333982'  
    };

//get the current page URL and split it into an array to get just the page name
var pathArray = window.location.pathname.split( '/' );

if (pathArray.length > 1) {
    //if the URL path has a directory, the page name will be in the second index value (1)
    var pageName = pathArray[2];
    
    //set image variable to the page banner image string in the page_banner array
    var imageURL = page_banners[pageName];
    
    //set the banner image in the HTML to the value we just retrieved
    imageStr = "url('" + imageURL + "')";
    document.getElementById('banner').style.backgroundImage = imageStr;
}